import Axios from "axios";
import {
    SET_PRODUCTION_DYEING_LIST,
    UNSET_PRODUCTION_DYEING_LIST,
} from "@/store/mutation-types";
import { 
    dyeingResource
} from "@/store/api";

// initial state
const state = {
    getDyeingList: [],
};

const getters = {
    getDyeingList(state) {
        return state.getDyeingList;
    },
};

const mutations = {
    [SET_PRODUCTION_DYEING_LIST](state, data) {
        state.getDyeingList = data;
    },
    [UNSET_PRODUCTION_DYEING_LIST](state) {
        state.getDyeingList = [];
    },
};

const actions = {
    saveDyeing({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(dyeingResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateDyeing({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            const id = data.id;
            // Remove id from payload, backend uses URL parameter
            const { id: _, ...payload } = data;
            Axios.put(`${dyeingResource}/${id}`, payload)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getDyeingList({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(dyeingResource)
                .then(function (response) {
                    // Ensure we have the correct response structure
                    const data = response.data?.data || response.data || [];
                    commit('SET_PRODUCTION_DYEING_LIST', data);
                    resolve(response);
                })
                .catch(function (error) {
                    console.error('Error fetching dyeing list:', error);
                    if (error.response) {
                        console.error('Error response:', error.response.data);
                    }
                    commit('UNSET_PRODUCTION_DYEING_LIST');
                    reject(error);
                });
        });
    },

    getDyeingById({ commit }, data) {
        const getDyeingById = `${dyeingResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getDyeingById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};

